import type { Documento } from "../documenti";

export const documentiFixtures: Documento[] = [
  {
    id: "ricevuta-candidatura",
    nome: "Ricevuta invio candidatura.pdf",
    tipo: "PDF",
    dimensione: 184000,
    aggiornatoIl: "2026-09-28T16:12:00.000Z",
    stato: "Verificato",
    descrizione: "Ricevuta protocollata della presentazione del progetto.",
    collegatoA: "Riqualificazione degli spazi pubblici",
    collegamentoTipo: "Progetto",
  },
  {
    id: "delibera-42-2026",
    nome: "Delibera di Giunta n. 42-2026.pdf",
    tipo: "PDF",
    dimensione: 2480000,
    aggiornatoIl: "2026-10-14T09:20:00.000Z",
    stato: "Verificato",
    descrizione: "Atto approvato dalla Giunta comunale per la candidatura.",
    collegatoA: "Riqualificazione degli spazi pubblici",
    collegamentoTipo: "Bando",
  },
  {
    id: "quadro-economico",
    nome: "Quadro economico progetto.xlsx",
    tipo: "XLSX",
    dimensione: 486000,
    aggiornatoIl: "2026-10-13T15:40:00.000Z",
    stato: "Da verificare",
    descrizione: "Prospetto dei costi e delle quote di cofinanziamento.",
    collegatoA: "Riqualificazione degli spazi pubblici",
    collegamentoTipo: "Progetto",
  },
  {
    id: "carta-identita-denise",
    nome: "Documento di identità Denise.jpg",
    tipo: "JPG",
    dimensione: 1320000,
    aggiornatoIl: "2026-10-10T11:05:00.000Z",
    stato: "Verificato",
    descrizione: "Documento del responsabile della pratica.",
    collegatoA: "Anagrafica del Comune",
  },
  {
    id: "relazione-biblioteca",
    nome: "Relazione attività Biblioteca 2025.docx",
    tipo: "DOCX",
    dimensione: 912000,
    aggiornatoIl: "2026-10-07T08:15:00.000Z",
    stato: "Da verificare",
    descrizione: "Relazione sulle attività svolte e sui risultati raggiunti.",
    collegatoA: "Rendiconto Biblioteca comunale 2025",
  },
];
